import React from "react";

export const DashboardContext = React.createContext();

export const DashboardProvider = (props) => {
  const tooltipXPos = React.useRef(null);

  const defaultContext = {
    tooltipXPos,
  };

  return <DashboardContext.Provider value={defaultContext}>{props.children}</DashboardContext.Provider>;
};

export const useDashboard = () => React.useContext(DashboardContext);
